import clientApi from "@/shared/api/client"

export type DemandSignalType = "REVIEW" | "CONSULT_WAITLIST"

export type DemandSignalSubmitRequest = {
  signalType: DemandSignalType
  content?: string
  /** CONSULT_WAITLIST 만 보낸다. 리뷰에 실어 보내도 서버가 버린다. */
  contactValue?: string
  consent?: boolean
  /** 중복 제출 판정용. 리뷰에 쓴다. */
  sessionKey?: string
}

export const DEMAND_SIGNAL_URL = {
  SUBMIT: (hospitalOriginId: number) =>
    `/hospital/apis/hospital/unrestricted/demand-signal/${hospitalOriginId}`,
}

export const submitDemandSignal = async (
  hospitalOriginId: number,
  body: DemandSignalSubmitRequest,
): Promise<void> => {
  const response = await clientApi.post<{ status: number }>(DEMAND_SIGNAL_URL.SUBMIT(hospitalOriginId), body)
  // 기존 API는 업무 오류도 HTTP 200으로 반환한다. 본문의 성공 상태까지 확인한다.
  if (response.data?.status !== 200) throw new Error("Demand signal submission failed")
}
